import React from 'react';
import { textLineBreak } from 'libs/textLineBreak';
import { Modal, Button } from 'antd';

const TermsAndConditionsText = `
 제1조(목적)

    본 약관은 "서비스" 이용자가 (주)빅스텝에듀케이션 (이하 '회사')가 제공하는 온라인 취업 멘토링 플랫폼(bigstepedu.com) 및 제공되는 일체의 서비스(이하 '서비스’)를 이용함에 있어 회사와 회원의 권리와 의무 및 책임 사항, 이용 절차, 그리고 기타 필요한 사항을 규정함을 목적으로 합니다.


    제2조(용어의 정의)

    이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

    "서비스": 회사가 제공하는 수업과 교정 및 이용가능한 콘텐츠 일체

    "회원" : 회사와 "서비스" 이용 계약을 체결하고 회사가 제공하는 "서비스"를 이용하는 자

    "이메일(ID)" : 인터넷 메일 계정. 회사는 "회원"의 “이메일”을 “회원” 식별과 "회원"의 "서비스" 이용을 위한 고유의 아이디(ID)로 사용함

    "비밀번호" : "회원"의 “이메일(ID)”과 일치된 "회원"임을 확인하고, "회원" 자신의 비밀을 보호하기 위하여 "회원"이 정한 문자와 숫자의 조합

    "관리자" : "서비스"의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람

    “수강권” : 빅스텝에듀 1:1 영어회화 또는 인터뷰 수업 1회 단위를 수강권이라 함. 수강권 1개는 멘토링 1회를 의미함.

    “패키지” : 빅스텝에듀가 2개 이상의 수강권을 묶음으로 판매하는 단위를 의미함. 예로, 5회 패키지는 곧 멘토링 5회(수강권 5개)의 묶음을 의미함.


    제3조(약관의 효력과 변경)

    회사는 이 약관의 내용을 "회원"이 쉽게 알 수 있도록 "서비스" 사이트 초기 화면에 게시합니다.

    회사는 이 규정을 변경할 수 있으며, 변경된 규정은 제1항과 같은 방법으로 공지함으로써 효력을 발생합니다.

    회사는 약관을 개정하는 경우 개정 사유 및 시행일자를 명시하여 현행약관과 함께 시행일로부터 최소 7일 전에 제1항의 방법으로 공지합니다. 단, "회원"의 권리 또는 의무에 관한 중요한 규정의 변경은 최소 30일전에 공지하고 개정약관을 "회원"이 등록한 “이메일”로 발송하여 통지합니다.

    회사의 제3항에 따른 개정약관 공지 또는 통지 후 "회원"이 약관 변경 적용일까지 명시적으로 거부의사를 표시하지 않은 경우 "회원"이 개정약관에 동의한 것으로 봅니다. 단, "회원"은 변경된 약관에 동의하지 않는 경우 "서비스"의 이용을 중단하고 이용계약을 해지할 수 있습니다.

    "회원"은 약관의 변경에 대하여 주의의무를 다하여야 하며, 변경된 약관의 부지로 인한 "회원"의 피해는 회사가 책임지지 않습니다.


    제4조(약관의 준칙)

    이 약관에 명시되지 않은 사항과 이 약관의 해석에 관하여는 전기통신기본법, 전기통신사업법, 온라인 디지털콘텐츠산업 발전법, 전자상거래 등에서의 소비자보호 관련 법률, 정보통신망이용촉진 및 정보보호 등에 관한 법률 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 문화체육관광부장관이 정하는 디지털콘텐츠이용자보호지침, 기타 관계법령 또는 상관례에 따릅니다.


    제5조(이용 계약의 성립)

    이용 계약은 이용자의 이용 신청에 대한 회사의 이용 승낙과 이용자의 약관 내용에 대한 동의로 성립됩니다.

    "회원"에 가입하여 "서비스"를 이용하고자 하는 자는 회사에서 요청하는 개인신상정보를 제공해야 합니다.

    회사는 다음 각 호에 해당하는 이용 신청에 대하여는 승낙하지 아니할 수 있습니다.

    1) 이름이 실명이 아니거나 다른 사람의 명의를이용한 경우

    2) 이용 신청 시 필요 내용을 허위로 기재하여 신청한 경우

    3) 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청한 경우

    4) 기타 회사가 정한 이용 신청요건이 미비 된 경우


    제6조(계약 사항의 변경)

    "회원"은 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, "서비스" 관리를 위해 필요한 이메일(ID)는 수정이 불가능합니다.

    "회원"은 가입시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 변경사항을 알려야 합니다.

    제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.


    제7조(개인정보보호 의무)

    회사는 이용자의 정보 수집 시 "서비스" 이용을 위한 최소한의 정보를 수집합니다.

    회사가 이용자의 개인 식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다. 제공된 개인정보는 당해 이용자의 동의 없이 목적 외로 이용하거나 제3자에게 제공할 수 없으며 이에 대한 모든 책임은 회사가 집니다.

    이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집 목적 및 이용 목적, 제3자에 대한 정보 제공 관련 사항(제공 받는 자, 제공 목적 및 제공할 정보의 내용), 수탁업체에 대한 정보제공 관련사항(수탁자, 위탁업무 내용 및 정보제공 항목) 등 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’이라 함)에 규정한 사항을 미리 명시하거나 고지해야 하며 “회원”은 언제든지 이 동의를 철회할 수 있습니다.

    회사는 개인정보 보호를 위하여 "관리자"를 최소한의 수로 한정하며 이용자 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.

    회사 또는 그로부터 개인정보를 제공 받는 제3자는 개인 정보의 수집목적 또는 제공 받는 목적을 달성할 때에는 당해 개인정보를 지체 없이 파괴합니다.


    제8조 ("회원"의 "이메일(ID)" 및 "비밀번호" 관리 의무)

    "회원"의 "이메일(ID)"와 "비밀번호"에 관한 관리책임은 "회원"에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.

    회사는 "회원"의 "이메일(ID)"가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 회사 및 회사의 운영자로 오인한 우려가 있는 경우, 해당 "이메일(ID)"의 이용을 제한할 수 있습니다.

    "회원"은 "이메일(ID)" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.

    제3항의 경우에 해당 "회원"이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.


    제9조(정보 제공 및 "회원"에 대한 통지)

    회사는 "회원"이 "서비스" 이용 중 필요하다고 인정되는 다양한 정보를 전자우편, 유선, 서신우편 등의 방법으로 "회원"에게 제공할 수 있습니다.


    제10조(회사의 의무)

    회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 "서비스"를 제공할 의무가 있습니다.

    회사는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않습니다.

    "서비스" 이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. "회원"이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 "회원"에게 처리과정 및 결과를 전달합니다.

    회사는 "회원"의 개인정보(신용 정보 보호) 보호를 위해 보안 시스템을 갖추며, 본인 승낙 없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신 기본법 등 법률의 규정에 의해 국가 기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보 통신 윤리위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우에는 그리하지 않습니다.


    제11조("회원"의 의무)

    "회원"은 "서비스"를 이용할 때 다음 각 호의 행위를 하지 않아야 합니다.

    1) 신청 또는 변경 시 허위내용의 등록

    2) 타인의 정보도용

    3) 회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해

    4) 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위

    5) "서비스" 이용시 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 언행

    6) 회사의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위

    7) 기타 불법적이거나 부당한 행위

    "회원"은 내용별로 회사가 공지사항에 게시하거나 별도로 공지한 이용제한 사항을 준수하여야 합니다

    "회원"은 회사의 "서비스"를 이용하여 얻은 정보를 가공, 판매하는 행위 등 "서비스"에 기재된 자료를 상업적으로 사용하거나 "서비스"를 이용해 영업활동을 할 수 없습니다. 단, 비상업적 목적일 경우에는 회사의 사전 동의를 얻어 사용할 수 있습니다.


    제12조("서비스" 제공 및 중단)

    "서비스"의 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다.

    회사는 "서비스"를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.

    컴퓨터 등 시스템 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 "관리자"가 임의로 날짜와 시간을 정해 "서비스"의 제공을 일시 중단할 수 있습니다. 이 경우 "회원"에게 사전 공지를 원칙으로 하며, 부득이한 사유가 있을 경우 사후에 통지할 수 있습니다.

    회사는 제공하고 있는 "서비스"의 일부 또는 전부를 변경할 수 있습니다. "서비스" 이용 방법과 내용, 이용 시간 등에 변경이 있는 경우에는 변경 사유와 변경 내용, 제공일자 등을 변경 전 7일 이상 "서비스" 초기 화면에 게시하여야 합니다.


    제13조(멘토링 진행, 일정 변경 및 취소)

    멘토링 일정 변경 및 취소는 멘토가 배정되어 있는 수업의 경우, 수업 시작 24시간 이전까지는 (예: 수업 시작 28시간 전) 언제든 가능합니다. 멘토가 배정되어 있는 수업에 대해, 수업 시작 시간 24시간 이내 수업을 취소하는 경우 (예: 수업 시작 16시간 전) 수강권이 차감됩니다. 단, 멘토가 수락하지 않은 멘토링의 경우, 언제든 멘토링 취소/변경이 가능합니다.


    또한, 수강권 유효기간이 만료되는 경우에도 수강권이 자동 소멸됩니다. 삭제 또는 소멸된 수강권에 대해서는 환불을 제공하지 않습니다.

    고객의 잘못으로 인한 수강권 삭제 관련하여, 이의가 존재하는 경우  "회원"은 회사 측에 통보해야 하며,  해당 "회원"이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.

    "회원"의 수업 지각시 지각분을 보충해드리지 않습니다. 수업은 정시 시작, 종료를 원칙으로 합니다. 단, "멘토" 지각시 수업 시작 시점부터 90분 간 수업을 진행해 드립니다.


   제 14조(환불규정)


   회사는 서울시간대 기준 2020년 11월 23일 구매건부터 아래 원칙에 의거하여 회원에게 환불을 제공합니다.


    1) 무료로 제공된 수업 또는 진행 완료된 수업 또는 수강권이 차감된 수업 (예: 수업 시작 24시간 이내에 취소된 수업, 수강생이 노쇼한 수업 등)에 대해서는 환불이 불가능합니다.


    2) 회원이 구매한 유료수업에 대한 환불은 아래의 기준에 해당하지 않은 경우 진행 가능합니다. 유료수업 중 환불 불가능한 수강권은 아래와 같습니다.

    2-1) 회사는 유효기간이 절반 이하 남은 수강권에 대해서는 환불을 제공하지 않습니다. (예: 유효기간 60일 수강권의 경우, 유효기간이 30일 되는 시점부터 환불이 불가능합니다). 단, 유효기간 연장은 ‘빅스텝에듀 유효기간 연장 규정’에 의거하여 제공합니다.

    2-2) 회사는 회원이 구입한 패키지의 수업이 절반 이하 되는 시점부터 환불이 불가능합니다 (예: 회원이 5회 패키지를 구입한 경우, 수업이 2회 남은 시점부터 환불이 불가능합니다). 단, 유효기간 연장은 ‘유효기간 연장 규정’에 의거하여 제공합니다.

    2-3) 회사는 유효기간이 연장된 수강권(수업)은 환불이 불가능합니다.

    2-4) 회사는 수강증/출석확인증이 발급된 수업에 대해서는 환불이 불가능합니다


    3) 회사는 환불 가능한 수강권에 대해 회사의 환불 계산 공식에 의거하여 환불 가능 금액을 산정 후 환불을 제공합니다.

    3-1) 회원이 아직 수업을 개시하지 않은 패키지에 대해서는, 위의 14조 2월 1일부터의 환불규정 2-4)에 해당하지 않는 한 전액 환불을 제공합니다 (예: 5회 패키지 구매 후, 한 개의 수업도 수강하지 않아서 유효기간이 계속 멈춰있는 패키지에 대한 요청 시, 수강증/출석확인증 발급이 안된 경우에는 전액 환불 제공)

    3-2) 회원이 수강을 시작한 패키지에 대한 환불을 요청하는 경우 (예: 5회 패키지에 대해 2회 수업을 수강한 후 나머지 3회에 대해 환불 요청), 14조 환불규정의 ‘환불 불가능 수업’에 해당하지 않는 수업에 한해, 실결제 금액에서 이미 진행한 수업에 대한 ‘정가 수업료’를 차감한 금액 만큼 환불해 드립니다 (환불 가능 금액 = 결제 금액 - 정가 수업료 * 기 진행한 수업 수). 이미 진행한 수업에 대한 ‘정가 수업료’는 수강권 관리 페이지에서 확인 가능합니다.

    3-3) 환불 금액 지급 방식은, 회원이 신용카드로 결제했을 시 결제 취소를 통해, 계좌 이체로 결제했을 시 송금의 방식으로 제공드립니다.


    제15조(수강권 유효기간 차감, 연장 및 소멸한 수강권에 대한 복구 규정)


    회사는 아래조항에 의거하여 유효기간 차감을 진행합니다.

    1) 패키지의 유효기간은 첫 수업을 완료한 시점부터 60일이며, 패키지 내 모든 수강권의 유효기간이 자동으로 차감되기 시작합니다. (예: 5회 패키지 이용 시, 첫 수업 완료 시점부터 나머지 4개 수강권의 유효기간이 자동 차감되기 시작함). 또는, 패키지 구매 후 5년이 되는 시점부터, 유효기간이 자동으로 차감되기 시작합니다.

    2) 패키지 유효기간 연장 신청은 유효기간이 처음으로 절반 이하로 떨어지는 시점부터 가능합니다 (예: 5회 30일 패키지의 경우, 유효기간이 15일 이하가 되는 시점부터, 유효기간 연장이 가능함). 패키지의 유효기간 연장을 위한 금액은 ‘유효기간 연장 금액 규정'에서 확인 가능하며, 수강권 관리 페이지에 게재되어 있습니다.

    3) 유효기간이 소멸된 수강권은, 소멸이 된 후 3개월 이내만 부활이 가능합니다. 수강권 부활을 위한 금액은 ‘수강권 부활금액 규정'에서 확인 가능하며, 수강권 관리 페이지에 게재되어 있습니다.


    제16조(저작권의 귀속 및 이용제한)

    회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.

    이용자는 회사를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙없이 복제, 송신, 출판, 배포, 방송하거나 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.

    회사는 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다.


    서울 시간대 기준 2020년 11월 23일부터 진행되는 수업 및 서비스 결과로 발생한 자료 및 데이터 저작권은 회사 및 회원 양측에 귀속됩니다. 회사는 수업 및 서비스 도중 발생한 결과물에 대해 non-disclosure agreement (NDA)를 이행하여, 데이터/자료가 고객 정보와 함께 그대로 외부에 노출되지 않도록 최선을 의무를 이행합니다. 단, 데이터/자료는 개인식별이 불가능한 형태로 저장되며, 회사는 해당 데이터/자료를 연구 및 제품개발 목적으로 이용할 수 있는 권한을 갖습니다. 회원의 동의가 있을 시, 또는 무료로 제공되는 기능에 대해서는 마케팅 및 홍보 목적으로 결과물을 이용 가능합니다.


    제17조(계약 해지 및 "서비스" 이용 제한)

    "회원"이 이용 계약을 해지하고자 하는 때에는 "회원" 본인이 온라인을 통해 회사에 해지 신청을 하여야 합니다.

    회사는 "회원"이 다음 각 호에 해당하는 행위를 하였을 경우 사전통지 없이 이용 계약을 해지 하거나 또는 기간을 정하여 "서비스" 이용을 중지할 수 있습니다.

    1) 타인의 "이메일(ID)" 및 "비밀번호"를 도용한 경우

    2) "서비스" 운영을 고의로 방해한 경우

    3) 가입한 이름이 실명이 아닌 경우

    4) 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우

    5) "회원"이 국익 또는 공익 저해 목적으로 "서비스" 이용을 계획 또는 실행하는 경우

    6) 회사나 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우

    회사는 제2항의 규정에 의하여 이용 제한을 하고자 하는 경우에는 그 사유, 일시 및 기타사항을 정하여 이메일 또는 기타 방법에 의하여 해당 이용자 또는 대리인에게 통지 합니다. 다만, 회사가 긴급하게 이용을 정지할 필요가 있다고 인정하는 경우에는 그러하지 아니 합니다.

    제2항의 규정에 의하여 이용 정지의 통지를 받은 이용자 또는 그 대리인은 그 이용 정지의 통지에 대하여 이의가 있을 때에는 이의 신청을 할 수 있습니다.

    회사는 제3항의 규정에 의한 이의 신청에 대하여 그 확인을 위한 기간까지 이용 정지를 일시 연기 할 수 있으며, 그 결과를 이용자 또는 그 대리인에게 통지합니다.

    회사는 이용정지 기간 중에 그 이용 정지 사유가 해소된 것이 확인된 경우에는 이용 정지 조치를 즉시 해제 합니다.


    제18조(손해배상)

    회사는 일체의 무료로 제공되는 "서비스"의 이용과 관련하여 "회원"에게 발생한 어떠한 손해에 관하여도 책임을 지지 않습니다.


    제19조(면책조항)

    회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.

    회사는 "회원"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여 책임을 지지 않습니다.

    회사는 "회원"이 "서비스"에 기재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.


    제20조(관할 법원)

    "서비스"의 이용으로 발생한 분쟁에 대해 소송이 제기 될 경우 회사의 본사 소재지를 관할하는 법원을 관할 법원으로 합니다.
`;
type TTermsModalProps = {
  visible: boolean;
  setVisible: any;
};
const TermsAndConditionsModal = ({ visible, setVisible }: TTermsModalProps) => {
  function handleCancel() {
    setVisible(false);
  }

  return (
    <Modal
      title={<strong>이용약관</strong>}
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={<Button onClick={handleCancel}>닫기</Button>}
      width={800}
      onCancel={handleCancel}
    >
      {textLineBreak(TermsAndConditionsText)}
    </Modal>
  );
};

TermsAndConditionsModal.defaultProps = {};

export default TermsAndConditionsModal;
